import React, { useState } from "react";
import Papa from "papaparse";
import { createPromsFromJson } from "../../models/actions/Proms";
import { labels } from "../shared/translations";

const CsvToJson = ({
  snackbarShowErrorMessage,
  snackbarShowMessage,
  setLoading,
}) => {
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    let res = [];
    if (file && file.type === "text/csv") {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async function (results) {
          setLoading(true);
          res = results.data.map((item) => ({
            displayName: item.displayName,
            date: item.date,
            trento_0: item.wellness_sleep,
            trento_1: item.wellness_sleep_hours,
            trento_5: item.wellness_mood,
            trento_2: item.wellness_stress,
            trento_4: item.wellness_soreness,
            trento_6: item.wellness_sorenesslocation,
            trento_3: item.wellness_fatigue,
          }));
          const resultsBE = await createPromsFromJson({
            results: res,
            prom_key: "wellness_score_trento",
          });
          setLoading(false);
          if (resultsBE.message) {
            snackbarShowMessage(res.message);
          }
          if (resultsBE.error) {
            snackbarShowErrorMessage(res.error);
          }
        },
      });
    } else {
      snackbarShowErrorMessage(
        labels.patient.controlQuestions.selectProms.loadError
      );
    }
  };

  return (
    <div className="p-4">
      <input type="file" accept=".csv" onChange={handleFileUpload} />
    </div>
  );
};

export default CsvToJson;
